import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { SaleEvent } from '@core/models';
import { MlbScheduleApiResponse } from '@core/models/mlb-stats.model';
import {
  ApiException,
  BaseConnectionService,
} from '@core/services/base-connection.service';
import { catchError, map, Observable, of, Subject, throwError } from 'rxjs';
import { ConfigurationService } from './configuration.service';

@Injectable({
  providedIn: 'root',
})
export class MlbStatsConnectionService extends BaseConnectionService {
  private http = inject(HttpClient);
  private configurationService = inject(ConfigurationService);
  eventSubject: Subject<SaleEvent> = new Subject<SaleEvent>();
  token: string;

  constructor() {
    super();
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };
  }

  protected override handleApiResponse<T>(
    observable: Observable<T>
  ): Observable<T> {
    return observable.pipe(
      map(obj => {
        return obj;
      }),
      catchError(error => {
        console.error('API ERROR: ', error);
        return throwError(() => new ApiException(error.error.error));
      })
    );
  }

  protected override sendRequest<T>(
    http: HttpClient,
    endpoint: string,
    body: any = null
  ) {
    const finalUrl = `${endpoint}`;
    const observable = body
      ? http.post<T>(finalUrl, body, this.httpOptions)
      : http.get<T>(finalUrl, this.httpOptions);
    return this.handleApiResponse(observable);
  }

  getSchedule() {
    const endpoint = `https://statsapi.mlb.com/api/v1/schedule?sportId=1&teamId=${this.configurationService.configuration.teamId}`;
    return this.sendRequest<MlbScheduleApiResponse>(this.http, endpoint);
  }
}
